import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type DotCheckBoxProps = {
    /** Callback volaný na kliknutí */
    onChange?: (checked: boolean) => void;
    /** Příznak, zda je pole určené pouze pro čtení, deaktivuje možnost kliknutí */
    readOnly?: boolean;
    /** Nápověda po najetí myši */
    title?: string;
    /** Příznak, zda je pole zaškrtnuté */
    value: boolean;
};

const classNames = bemClassNames("dot-check-box-component");

/** Dvoustavové tečkové zaškrtávací pole bez štítku */
export const DotCheckBox: FunctionComponent<DotCheckBoxProps> = ({
    onChange,
    readOnly = false,
    title,
    value,
}) => {
    const handleClick = () => {
        if (!readOnly && onChange) {
            onChange(!value);
        }
    };

    return (
        <div
            onClick={handleClick}
            className={classNames()}
            title={title}
            tabIndex={1}
        >
            <input
                className={classNames("hidden-check-box")}
                readOnly
                type="checkbox"
                checked={value}
            />
            <div
                className={classNames("styled-check-box", {
                    "read-only": readOnly,
                    checked: value,
                    unchecked: !value,
                })}
            />
        </div>
    );
};
